<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Cohort</h2>
      </div>
    </div>

    <!-- Filters -->
    <div class="wrapper wrapper-content">

      <!-- Table -->
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">Cohort List</h5>
          <div class="d-flex">

            <div class="position-relative align-self-center"  :class="{ 'mr-3': CohortList.length != 0 }"
              aria-label="Create Cohort" tabindex="0" v-if="rollsprivilages.includes('Cohort Create Cohort')">
              <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17" alt="Create Cohort"
                @click="CreateCohort()" />
              <div class="tool-tip">Create Cohort</div>
            </div>
         
          </div>
        </div>
        <div class="ibox-content">
         
          <div class="text-center" v-if="showTableLoading === true">
            <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th  class="sort_block" @click="SortSelected('cohortName')">
                    <div class="d-flex flex-row justify-content-between">
                    Cohort Name
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th class="sort_block" @click="SortSelected('cohortCode')">
                    <div class="d-flex flex-row justify-content-between">
                    Cohort Code
                     <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                      </div>
                  </th>
                  <th  class="sort_block" @click="SortSelected('soAId')">
                    <div class="d-flex flex-row justify-content-between">
                    SoA ID
                     
                    </div>
                  </th>
                  <th class="sort_block" @click="SortSelected('dose.amount')">
                     <div class="d-flex flex-row justify-content-between">
                    Dose
                     <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  
                  <th class="sort_block" @click="SortSelected('designType')">
                     <div class="d-flex flex-row justify-content-between">
                    Design Type
                    <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                      </div>
                  </th>
                  <th class="text-center" v-if="rollsprivilages.includes('Cohort Edit')">Edit</th>
                  <th class="text-center"  v-if="rollsprivilages.includes('Cohort Delete')">Delete</th>
                </tr>
              </thead>
          <tbody>
  <tr v-for="item in CohortList" :key="item.Id || item.id">
    <td >{{ item.cohortName }}</td>  
    <td >{{ item.cohortCode }}</td>
    <td >{{ item.soAId }}</td>  
    <td >{{ item.dose?.amount }} {{ item.dose?.unit }}</td>
    <td >{{ item.designType }}</td> 
    <td class="text-center" v-if="rollsprivilages.includes('Cohort Edit')">
      <i class="fa fa-edit edit-delete" @click="EditCohort(item.Id || item.id)" style="color: #a13b7c"></i>
    </td>
    <td class="text-center" v-if="rollsprivilages.includes('Cohort Delete')">
      <i class="fa fa-trash edit-delete" style="color: #a13b7c" @click="DeleteCohort(item.Id || item.id)"></i>
    </td>
  </tr>
</tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="CohortList.length != 0" class="row mt-1 mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="
                  dataTables_paginate
                  paging_simple_numbers
                  pagination
                  float-right
                ">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <createcohortmodel
    v-if="showCreateCohortModal"
    :editingId="editingCohortId"
    @closeModal="closeCohortModal"
    @saved="refreshCohortList"
  />
</template>
<script src="./Cohort.js"></script>
